import * as Yup from 'yup'

export const PASSWORD_REQUIREMENTS = (
	Yup.string()
	.min(8, 'Must be at least 8 characters')
	.matches(
		/^(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z])(?=.*[^a-zA-Z\d]){1}).*$/,
		"Must contain one lowercase, uppercase, number and special character",
	)
)